import * as tslib_1 from "tslib";
import { AbstractSearchCriteria } from './abstract-search-criteria';
var ProfileTypeSearchCriteria = /** @class */ (function (_super) {
    tslib_1.__extends(ProfileTypeSearchCriteria, _super);
    function ProfileTypeSearchCriteria() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.code = '';
        _this.name = '';
        _this.codeOrName = '';
        _this.resourceType = '';
        return _this;
    }
    return ProfileTypeSearchCriteria;
}(AbstractSearchCriteria));
export { ProfileTypeSearchCriteria };
